import Typography from '@hellodarwin/core/lib/components/common/typography';
import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';
export const AcceptedApplicationCardContainer = styled.div `
  width: 100%;
  ${({ $fixedWidth }) => $fixedWidth && 'max-width: 400px;'}
  gap: 16px;
  padding: 20px 24px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.beige_2};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${(props) => props.$fixedHeight && 'min-height: 180px;'}
  &:hover {
    box-shadow: 0px 6px 11px 0px rgba(0, 0, 0, 0.12);
  }

  ${media.xl `
    gap: 24px;
    ${(props) => props.$fixedHeight && 'min-height: 240px;'}
  `}
`;
export const AcceptedApplicationProjectLine = styled.div `
  width: 100%;
  gap: 2px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const AcceptedApplicationRowContainer = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 4px;

  ${media.xl `
    flex-direction: column;
    align-items: flex-start;
  `}
`;
export const AcceptedApplicationRowLabelContainer = styled.div `
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  width: fit-content;

  ${media.xl `
    width: 100%;
  `}
`;
export const AcceptedApplicationRowValue = styled(Typography) `
  text-align: right;

  ${media.xl `
    text-align: left;
  `}
`;
export const CardContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
export const CardRow = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: top;
  justify-content: space-between;
`;
export const CardBody = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const CardSection = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  width: 100%;
  gap: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const CardSection2 = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  justify-content: left;
`;
